import { render, staticRenderFns } from "./AlineacionesCampbell.vue?vue&type=template&id=abd054f0&scoped=true"
import script from "./AlineacionesCampbell.vue?vue&type=script&lang=js"
export * from "./AlineacionesCampbell.vue?vue&type=script&lang=js"
import style0 from "./AlineacionesCampbell.vue?vue&type=style&index=0&id=abd054f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd054f0",
  null
  
)

export default component.exports